export const FileUtils = {
	async handleDownload({ url, name }: { url: string; name: string }) {
		console.log(url, name);

		const response = await fetch(url);
		const blob = await response.blob();

		const fileUrl = window.URL.createObjectURL(blob);

		const a = document.createElement("a");
		a.href = fileUrl;
		a.download = name; // desired filename
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	},
	async handlePreview({ url }: { url: string }) {
		const a = document.createElement("a");
		a.href = url;
		a.target = "_black"; // desired filename
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	},
};
